import { observer } from "mobx-react-lite";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import DistributorDetailViewModel from "viewModels/timeCharges/distributors/distributorManagement/distributorDetailViewModel";
import EditableDetailView from "../../../common/editableDetailView";
import DistributorForm from "./distributorForm";

const DistributorDetailView: ViewComponent<DistributorDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<DistributorForm vm={vm} />} />;
});

registerView(DistributorDetailView, DistributorDetailViewModel);
